// extracted by mini-css-extract-plugin
export default {"MediaPickerContainer":"MediaPicker_MediaPickerContainer__--p-6","WordpressButton":"MediaPicker_WordpressButton__5xV8Q"};